const PHONE_VERIFICATION_RESEND_COOLDOWNS_MS = [
  30000, 60000, 120000, 180000,
] as const;

/**
 * Returns the resend cooldown (in ms) after successfully sending a phone
 * verification SMS.
 *
 * `successfulSendCount` is 1-based:
 * - 0 or less: no cooldown
 * - 1: first cooldown value
 * - 2: second cooldown value
 * - 3+: capped at the last cooldown value
 */
const getPhoneVerificationCooldownMs = (
  successfulSendCount: number,
): number => {
  if (successfulSendCount <= 0) {
    return 0;
  }

  return PHONE_VERIFICATION_RESEND_COOLDOWNS_MS[
    Math.min(
      successfulSendCount - 1,
      PHONE_VERIFICATION_RESEND_COOLDOWNS_MS.length - 1,
    )
  ];
};

export default getPhoneVerificationCooldownMs;
